"use client";

import React from "react";
import type { HomePageProps } from "../../types";
import { SectionTypeEnum } from "@/generated/graphql";
import { EmptyCartIcon } from "@/assets/Icons/EmptyCartIcon";
import { EmptyState } from "@/components/UtilityComponents/EmptyState";
import ProductsSectionFallback from "../components/ProductsSectionFallback";
import { formatSections } from "@/shared/utils/homeHelpers";
import WhileInViewAnimation from "@/shared/globals/WhileInViewAnimation";
import { FormattedMessage } from "@/i18n/i18n-client";
import HeroRenderer from "@/Renderers/HeroRenderer";
import Hero from "../elements/Hero";
import HomeAbout from "../elements/HomeAbout";
import HomeContentSection from "../elements/HomeContentSection";
import HomeGallerySection from "../elements/HomeGallerySection";

const HomePage: React.FC<HomePageProps> = ({
  appearance,
  homepageSections,
  products,
}) => {
  const formattedSections = formatSections(homepageSections);

  return (
    <>
      <HeroRenderer Component={Hero} heroSettings={appearance?.heroSlider} />
      <HomeAbout aboutSettings={appearance?.about} />
      {formattedSections?.length ? (
        formattedSections.map((section, index) => {
          if (
            section.type === SectionTypeEnum.Text ||
            section.type === SectionTypeEnum.Embed
          ) {
            return (
              <WhileInViewAnimation key={section.id} amount={0.01}>
                <HomeContentSection section={section} />
              </WhileInViewAnimation>
            );
          }

          return (
            <HomeGallerySection
              key={section.id}
              section={section}
              index={index}
            />
          );
        })
      ) : products?.length ? (
        <ProductsSectionFallback products={products} />
      ) : (
        <EmptyState
          title={
            <FormattedMessage
              defaultMessage="There are no products added yet"
              id="dxKBho"
            />
          }
          image={<EmptyCartIcon />}
        />
      )}
    </>
  );
};

export default HomePage;
